// How a time entry came to exist, as shown in the Timesheets "Punch" column.
// entry_source: 'punch' | 'manual' | 'import' | 'recurring' | null (rows before migration 096).
export function entrySourceLabel(source) {
  switch (source) {
    case 'manual':
      return { label: 'typed', tooltip: 'Entered by hand — no clock in/out behind this entry' };
    case 'recurring':
      return { label: 'recurring', tooltip: 'Generated by a recurring contract schedule — not clocked' };
    case 'import':
      return { label: 'imported', tooltip: 'Imported from another system — not clocked' };
    default:
      return {
        label: '—',
        tooltip: 'Created before HourTrax recorded how entries were made — it may have been clocked or typed',
      };
  }
}

// Turn a failed GET /api/entries/:id/punches into what the reviewer should see.
// Never claims anything about how the entry was created.
export function punchLoadErrorMessage(err) {
  const status = err?.response?.status;
  if (status === 403) {
    return {
      severity: 'info',
      message: "You can't view the punch details for this entry. Punch evidence (location, network, device and photo) is visible only to admins, payroll admins and the employee's assigned manager — never to the employee themselves, including a manager looking at their own time.",
    };
  }
  if (status === 404) {
    return { severity: 'warning', message: 'This entry no longer exists. Refresh the list.' };
  }
  return { severity: 'error', message: 'Could not load punch details. Try again.' };
}

// Text when the request succeeded but returned no punches.
export function emptyPunchTrailMessage(entrySource) {
  if (entrySource === 'punch') {
    return 'This entry was clocked, but no punch record was saved for it, so there is no location, network or photo to show.';
  }
  return entrySourceLabel(entrySource).tooltip;
}

// Plan 109: an offline punch that arrived without a valid sync token was recorded at the
// server's time; the audit note keeps the device time and why it was not used.
const NOT_HONOURED_REASON = {
  NO_TOKEN: 'no sync token (older app version, or the device ran out of tokens while offline)',
  TOKEN_INVALID: 'sync token could not be verified',
  TOKEN_EXPIRED: 'sync token older than 72 hours',
  TIME_BEFORE_TOKEN: 'punch time earlier than its sync token',
};
export function offlineTimeNotHonoured(ev) {
  const m = /offline replay not honoured \((\w+)\): device time ([^\s;]+)/.exec(ev?.notes || '');
  if (!m) return null;
  const d = new Date(m[2]);
  return { code: m[1], deviceTime: isNaN(d.getTime()) ? m[2] : d.toLocaleString(), reason: NOT_HONOURED_REASON[m[1]] || m[1] };
}
